export default "__VITE_ASSET__5je9XLcm__"